module.exports = __webpack_public_path__ + "assets/img/1606_03.jpg?a7cb21be9cb2221b7dcb2eb97ab5f14d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1606_03.jpg
// module id = 1113
// module chunks = 0